<template>
  <Toast :close-tip="true" class="success" :close-event="closeEvent">
    <p class="success-info">1、好友领取，页面将自动刷新进度</p>
    <p class="success-info mt3">2、您可通过已分享的消息查看进度</p>
    <p class="success-btn" @click="close">我知道了</p>
  </Toast>
</template>

<script>
import Toast from "./../VueToast"
export default {
  name: 'SuccessShare',
  props: {
    closeEvent: Function
  },
  components: {
    Toast
  },
  methods: {
    close () {
      this.closeEvent();
    }
  }

}
</script>

<style lang="scss">
.success {
  .toast__content {
    padding-top: 43px;
    width: 250px;
    height: 286px;
    background-image: url("./../../../assets/img/share-succ-bg.png");
    background: -webkit-image-set(
      url("./../../../assets/img/share-succ-bg.png") 1x,
      url("./../../../assets/img/share-succ-bg@2x.png") 2x,
      url("./../../../assets/img/share-succ-bg@3x.png") 3x
    );
    background-repeat: no-repeat;
    background-size: 100%;
    box-sizing: border-box;
  }
  .success-info {
    font-size: 12px;
    color: rgba(255,255,255,00.8);
    letter-spacing: 0;
    text-align: center;
    line-height: 17px;
    &.mt3 {
      margin-top: 3px;
    }
  }
  .success-btn {
    height: 32px;
    width: 120px;
    margin: 152px auto 0;
    line-height: 32px;
    color: #fff;
    background-image: linear-gradient(180deg, #FEBD38 0%, #FFA124 100%);
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.10);
    border-radius: 100px;
  }
}
</style>